(() => {
  /**
   * ポイントキャッシュをクリアする。
   * @param {string} customerId - Shopify 顧客 ID
   */
  function clearPointCache(customerId) {
    localStorage.removeItem(`sanyo_app_current_point_${customerId}`);
    localStorage.removeItem(`sanyo_app_expire_date_${customerId}`);
  }

  /**
   * カートページ遷移時、または TTL 超過時にポイントキャッシュを削除する。
   */
  function checkPointCache() {
    const customerId = window.Aureme?.config?.customerId || '';
    const pointCacheTtl = Number(window.Aureme?.config?.pointCacheTtl);
    if (!customerId) return;

    const cachePointDate = localStorage.getItem(`sanyo_app_expire_date_${customerId}`);
    if (!cachePointDate) return;

    // 任意のロケール接頭辞(例: /ja, /en-us)を許容し、/cart およびその配下パスをカートページとして判定する
    const isCartPage = /^(\/[a-z]{2}(-[a-z]{2})?)?\/cart(\/|$)/.test(window.location.pathname);
    const isExpired = Date.now() - parseInt(cachePointDate, 10) >= pointCacheTtl;

    if (isCartPage || isExpired) {
      clearPointCache(customerId);
    }
  }

  checkPointCache();
})();
